
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("974eL", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $6a280de258797c30$export$2cd8252107eb640b; });
"use strict";
const $6a280de258797c30$export$2cd8252107eb640b = ()=>{
    let attempts = 0;
    const whenComplete = ()=>{
        if (++attempts > 30) return;
        if (document.readyState === "complete") $6a280de258797c30$var$initBMI();
        else setTimeout(whenComplete, 400);
    };
    whenComplete();
};
let $6a280de258797c30$var$dictionary = {
    obesityLevel5: 'Es besteht eine fortgeschrittene Adipositas. Es besteht m\xf6glicherweise eine Indikation zur metabolischen Chirurgie. Um weitere Details zu kl\xe4ren, verabreden Sie bitte einen Termin in unserer Sprechstunde unter der Telefonnummer <a href="tel:071127862666">0711 278-62666</a>. Wir beraten Sie gerne ausf\xfchrlich.',
    obesityLevel4: 'Es besteht eine fortgeschrittene Adipositas. Es besteht m\xf6glicherweise die prim\xe4re Indikation zur bariatrischen Chirurgie, falls keine Kontraindikationen gegen einen solchen Eingriff vorliegen. Wir beraten Sie gerne ausf\xfchrlich in unserer Sprechstunde. Bitte machen Sie einen Termin unter der Telefonnummer <a href="tel:071127862666">0711 278-62666</a> aus.',
    obesityLevel3: 'Es besteht eine fortgeschrittene Adipositas. Es ist m\xf6glich, dass bei Ihnen eine Indikation zur bariatrischen Chirurgie besteht. Vorher sollten jedoch auch die konservativen M\xf6glichkeiten der Gewichtsreduktion ausgesch\xf6pft werden. Hierf\xfcr sind mindestens sechs Beratungen bei einer zertifizierten Ern\xe4hrungsberatung und zweimal w\xf6chentlich Sport \xfcber mindestens sechs Monate notwendig. Lassen Sie sich auch von Ihrer Krankenkasse beraten. Konsultieren Sie Ihren Hausarzt, bevor Sie mit intensivem k\xf6rperlichem Training beginnen. Wir beraten Sie gerne ausf\xfchrlich in unserer Sprechstunde. Bitte machen Sie einen Termin unter der Telefonnummer <a href="tel:071127862666">0711 278-62666</a> aus.',
    obesityLevel2: 'Es besteht eine zweitgradige Adipositas. Es ist m\xf6glich, dass bei Ihnen eine Indikation zur metabolischen Chirurgie besteht. Vorher sollten jedoch auch die konservativen M\xf6glichkeiten der Gewichtsreduktion ausgesch\xf6pft werden. Hierf\xfcr sind mindestens sechs Beratungen bei einer zertifizierten Ern\xe4hrungsberatung und zweimal w\xf6chentlich Sport \xfcber mindestens sechs Monate notwendig. Lassen Sie sich auch von Ihrer Krankenkasse beraten. Konsultieren Sie Ihren Hausarzt, bevor Sie mit intensivem k\xf6rperlichem Training beginnen. Wir beraten Sie gerne in unserer Sprechstunde. Bitte machen Sie einen Termin unter der Telefonnummer <a href="tel:071127862666">0711 278-62666</a> aus.',
    obesityLevel1: 'Es besteht eine Adipositas. Sie sollten zur Gewichtsreduktion eine zertifiziert Ern\xe4hrungsberatung in Anspruch nehmen und mindestens zweimal pro Woche Sport treiben. Haben Sie schon \xfcber die Teilnahme an einem konservativ gef\xfchrten Programm zur Gewichtsreduktion nachgedacht, so ist m\xf6glicherweise das Optifast Programm genau das Richtige. N\xe4here Informationen erhalten Sie unter Telefon <a href="tel:071145924895">0711 459-24895</a> oder <a href="mailto:info@zkes-optifast.de">info@zkes-optifast.de</a>. Eine Indikation zur bariatrischen Chirurgie besteht eher nicht.',
    overWeight: 'Sie sind \xfcbergewichtig oder leichtgradig adip\xf6s. Wir empfehlen Ihnen eine strukturierte Ern\xe4hrungsberatung und ein Sportprogramm. Haben Sie schon \xfcber die Teilnahme an einem konservativ gef\xfchrten Programm zur Gewichtsreduktion nachgedacht, so ist m\xf6glicherweise das Optifast Programm genau das Richtige.  N\xe4here Informationen erhalten Sie unter Telefon <a href="tel:071145924895">0711 459-24895</a> oder <a href="mailto:info@zkes-optifast.de">info@zkes-optifast.de</a>.',
    normalWeight: "Sie haben Normalgewicht. Vermutlich ist keine \xe4rztliche Intervention notwendig.",
    underWeight: "Sie haben Untergewicht! Bitte sprechen sie mit Ihrem Hausarzt dar\xfcber und suchen sie weitere \xe4rztliche Hilfe."
};
function $6a280de258797c30$var$initBMI() {
    let formBmi = document.querySelector(".bmi_content");
    let inputHeight = formBmi.querySelector(".height");
    let inputWeight = formBmi.querySelector(".weight");
    let inputDiabetes = formBmi.querySelector(".diabetes");
    let btnCalculate = formBmi.querySelector(".calculate");
    let formResult = formBmi.querySelector(".output");
    let labelResultBMI = formBmi.querySelector(".resultbmi");
    let labelResult = formBmi.querySelector(".result");
    btnCalculate.addEventListener("click", ()=>{
        let height = parseFloat(inputHeight.value);
        let weight = parseFloat(inputWeight.value);
        let diabetes = inputDiabetes.value == 1;
        if (isNaN(height) || isNaN(weight)) {
            labelResult.innerText = "Bitte geben Sie eine g\xfcltige Gr\xf6\xdfe und Gewicht ein.";
            formResult.classList.add("visible", "error");
            return;
        }
        let bmi = weight / (height * height) * 10000;
        let resultText = "";
        if (diabetes) {
            if (bmi >= 40) resultText = $6a280de258797c30$var$dictionary.obesityLevel5;
            else if (bmi >= 35 && bmi < 40) resultText = $6a280de258797c30$var$dictionary.obesityLevel2;
        } else {
            if (bmi >= 50) resultText = $6a280de258797c30$var$dictionary.obesityLevel4;
            else if (bmi >= 35 && bmi < 50) resultText = $6a280de258797c30$var$dictionary.obesityLevel3;
        }
        if (bmi >= 30 && bmi < 35) resultText = $6a280de258797c30$var$dictionary.obesityLevel1;
        else if (bmi >= 25 && bmi < 30) resultText = $6a280de258797c30$var$dictionary.overWeight;
        else if (bmi > 18 && bmi < 25) resultText = $6a280de258797c30$var$dictionary.normalWeight;
        else if (bmi <= 18) resultText = $6a280de258797c30$var$dictionary.underWeight;
        labelResult.innerHTML = resultText;
        labelResultBMI.innerText = bmi.toFixed(2);
        formResult.classList.remove("error");
        formResult.classList.add("visible");
    });
}

});


//# sourceMappingURL=bmiRechner.module.470cc574.js.map
